import {Component, Input, OnInit} from '@angular/core';
import {ApprovalPending} from '../../../../shared/dto/approval-pending';
import {FormControl, FormGroup} from '@angular/forms';
import {ApprovalModel} from '../../../../shared/dto/approval.model';
import {UserRoleEnum} from '../../../../shared/enums/user-role.enum';
import {ApplicantRequestSearchModel} from '../../../../model/applicantRequestSearchModel';
import {BlacklistDetailsModel} from '../../../../shared/dto/blacklist-details.model';
import {ActivatedRoute, Router} from '@angular/router';
import {BlacklistApproveChecklistComponent} from '../../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TokenStorageService} from '../../../../shared/service/token-storage.service';
import {ReversedReturnRequestComponent} from '../../../../reversed-blacklist-process/reversed-process-verification/reversed-blacklist-verification-request-viewer/reversed-return-request/reversed-return-request.component';
import Swal from "sweetalert2";
import {ApprovalService} from '../../../../service/approval.service';
import {ReversedSuspendService} from '../../../../shared/service/reversed-suspend.service';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {WorkflowEnum} from '../../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-suspend-authorize-applicant-details',
  templateUrl: './reversed-suspend-authorize-applicant-details.component.html',
  styleUrls: ['./reversed-suspend-authorize-applicant-details.component.scss']
})
export class ReversedSuspendAuthorizeApplicantDetailsComponent implements OnInit {
  @Input() applicationId: number;
  @Input() fromParent;

  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  applicantSearchForm: FormGroup;
  public approvalPending: BlacklistDetailsModel;
  female: boolean;
  male: boolean;
  isError: boolean = false;
  isSucess: boolean = false;
  isErrorContact: boolean = false;
  isSucessContact: boolean = false;
  personalDto: ApprovalPending = new ApprovalPending();
  contactDto: ApprovalPending = new ApprovalPending();
  applicantRequestSearchDetails: ApplicantRequestSearchModel;
  approvalModel: ApprovalModel = new ApprovalModel();
  retrievedImage: string;
  base64Data: string;
  signature: string;
  imgrighthand: string;
  imglefthand: string;
  thumbright: string;
  thumbleft: string;
  public isValidChecklist = false;

  constructor(private suspendService: ReversedSuspendService, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService,
              private router: Router,private route: ActivatedRoute, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.type = params.get('type');
      this.userName = params.get(this.tokenStorageService.getUserObjectToken().username);
    });
  }

  ngOnInit() {
    this.applicantSearchForm = new FormGroup({
      remark: new FormControl(null),
      appRefNo: new FormControl(null),
      appType: new FormControl(null),
      status: new FormControl(null),
      createDate: new FormControl(null),
      cdcNo: new FormControl(null),
      cocNo: new FormControl(null),
      cdcExpDate: new FormControl(null),
      cocDate: new FormControl(null),
      fullName: new FormControl(null),
      familyName: new FormControl(null),
      givenName: new FormControl(null),
      initialName: new FormControl(null),
      nic: new FormControl(null),
      nicIssueDate: new FormControl(null),
      dob: new FormControl(null),
      gender: new FormControl(null),
      birthPlace: new FormControl(null),
      nationality: new FormControl(null),
      specialCharac: new FormControl(null),
      bioRefNo: new FormControl(null),
      photoDate: new FormControl(null),
      photoExpDate: new FormControl(null),
      address: new FormControl(null),
      mobile: new FormControl(null),
      sidNo: new FormControl(null),
      sidIssueDate: new FormControl(null),
      sidStatus: new FormControl(null),
      sidExpiryDate: new FormControl(null),
      passportNo: new FormControl(null),
      passportPhotoDate: new FormControl(null),
      photoExpiryDate: new FormControl(null),
      email: new FormControl(null),
    });

    this.isValidChecklist = false;
    this.onSearch();

    this.getApplicantDetails();
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }

  decodeBase64(code: string): string {
    return atob(code);
  }

  onSearch() {
    this.suspendService.searchApplicantDetails(this.applicationId).subscribe(
      (data: any ) => {
        this.approvalPending = data;
        this.applicantSearchForm.patchValue(
          {
            remark: this.approvalPending.remark,
            status: this.approvalPending.stage,
            appType: this.approvalPending.type,
            nic: this.approvalPending.nic,
            createDate: this.approvalPending.createdDate,
            fullName: this.approvalPending.name,
            appRefNo: this.approvalPending.appRefNo,
            cdcNo: this.approvalPending.cdcNo,
            cocNo: this.approvalPending.cocNo,
            cdcExpDate: this.approvalPending.cdcExpDate,
            cocDate: this.approvalPending.cocDate,
            familyName: this.approvalPending.familyName,
            givenName: this.approvalPending.givenName,
            initialName: this.approvalPending.initialName,
            nicIssueDate: this.approvalPending.nicIssueDate.toString().substring(0, 10),
            dob: this.approvalPending.dob.toString().substring(0, 10),
            gender: this.approvalPending.gender,
            birthPlace: this.approvalPending.birthPlace,
            nationality: this.approvalPending.nationality,
            specialCharac: this.approvalPending.specialCharac,
            bioRefNo: this.approvalPending.bioRefNo,
            photoDate: this.approvalPending.photoDate,
            photoExpDate: this.approvalPending.photoExpDate,
            address: this.approvalPending.address,
            mobile: this.approvalPending.mobile,
            email: this.approvalPending.email,
            sidNo: this.approvalPending.sidNo,
            sidIssueDate: this.approvalPending.sidIssueDate,
            sidExpiryDate: this.approvalPending.sidExpiryDate,
            passportNo: this.approvalPending.passportNo,
            passportPhotoDate: this.approvalPending.passportPhotoDate,
            photoExpiryDate: this.approvalPending.photoExpiryDate,
            sidStatus: this.approvalPending.stage,
          }
        );

        if (this.approvalPending.gender === 'Male') {
          this.male = true;
          this.female = false;
        }
        if (this.approvalPending.gender === 'Female') {
          this.male = false;
          this.female = true;
        }
      }
    );
  }

  getApplicantDetails(){
    this.approvalService.getApplicantDetails(this.applicationId).subscribe(
      (data: ApplicantRequestSearchModel) =>{
        this.applicantRequestSearchDetails = data;
        this.applicantSearchForm.patchValue(
          {
            bioRefNo: this.applicantRequestSearchDetails.reference,
            photoDate: this.applicantRequestSearchDetails.expiryDate,
            photoExpDate: this.applicantRequestSearchDetails.expiryDate,
          }
        );
        this.retrievedImage = this.applicantRequestSearchDetails.image;
        this.signature = this.applicantRequestSearchDetails.imgsignature;
        this.imgrighthand = this.applicantRequestSearchDetails.imgrighthand;
        this.imglefthand = this.applicantRequestSearchDetails.imglefthand;
        this.thumbright = this.applicantRequestSearchDetails.thumbright;
        this.thumbleft = this.applicantRequestSearchDetails.thumbleft;

        this.base64Data = window.atob(this.retrievedImage);
      }
    )
  }

  savePersonalData() {
    this.personalDto.name = this.applicantSearchForm.value.fullName;
    this.personalDto.familyName = this.applicantSearchForm.value.familyName;
    this.personalDto.givenName = this.applicantSearchForm.value.givenName;
    this.personalDto.initialName = this.applicantSearchForm.value.initialName;
    this.personalDto.nic = this.applicantSearchForm.value.nic;
    this.personalDto.nicIssueDate = this.applicantSearchForm.value.nicIssueDate;
    this.personalDto.dob = this.applicantSearchForm.value.dob;
    this.personalDto.gender = this.applicantSearchForm.value.gender;
    this.personalDto.birthPlace = this.applicantSearchForm.value.birthPlace;
    this.personalDto.specialCharac = this.applicantSearchForm.value.specialCharac;
    this.personalDto.appRefNo = this.approvalPending.appRefNo;
    this.personalDto.loginUser = this.userName;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to update the applicant details?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.proceedPersonalData(this.personalDto).subscribe(
          (success: string) => {
            this.isSucess = true;
          },
          (error) => {
            this.isError = true;
          },
        );
      } else {
      }
    });
  }

  saveContactData() {
    this.contactDto.appRefNo = this.approvalPending.appRefNo;
    this.contactDto.loginUser = this.userName;
    this.contactDto.email = this.applicantSearchForm.value.email;
    this.contactDto.address = this.applicantSearchForm.value.address;
    this.contactDto.mobile = this.applicantSearchForm.value.mobile;

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to update the contact details?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.approvalService.proceedContactData(this.contactDto).subscribe(
          (success: string) => {
            this.isSucessContact = true;
          },
          (error) => {
            this.isErrorContact = true;
          },
        );
      } else {
      }
    });
  }

  blacklistData() {

    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.APPROVE;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.process = ActionMode.REVERSE_SUSPEND;
    this.approvalModel.stage = WorkflowEnum.SUSPEND_REVERSED;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  returnBlacklist() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = ActionMode.RETURN;
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.process = ActionMode.REVERSE_SUSPEND;

    const modalRef = this.modalService.open(ReversedReturnRequestComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

}
